import { Badge } from '@/components/ui/badge'
import type { ResultadoComunicaciones } from '@/types/afip'

/** Cuántas comunicaciones trajo la consulta, si faltan por el tope de páginas y cuántas siguen sin leer. */
export function ResumenComunicaciones({ resultado }: { resultado: ResultadoComunicaciones }) {
  const total = resultado.totalRegistros
  const noLeidas = resultado.comunicaciones.filter((c) => c.estado === 'NO_LEIDA').length

  return (
    <div className="flex items-center gap-3 text-sm">
      <span className="text-muted-foreground">
        {total === 0
          ? 'No hay comunicaciones para los filtros aplicados'
          : total === 1
            ? '1 comunicación encontrada'
            : `${total} comunicaciones encontradas`}
      </span>
      {resultado.truncado && (
        <span className="text-amber-700 dark:text-amber-400">
          Hay más comunicaciones de las que se pueden mostrar. Acortá el período.
        </span>
      )}
      {noLeidas > 0 && <Badge variant="destructive">{noLeidas} sin leer</Badge>}
    </div>
  )
}
